<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('location.Toiler_disease_free') }}</h5>    
    <p class="mb-0 text-sm">{{ $t('location.Optional_information') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-4">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Disease_free') }}</label>                  
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.isToilerDiseaseFree" id="isToilerDiseaseFree" name="isToilerDiseaseFree" />
            </div>
          </div>
        </div>               
        <div class="col-6">
          <div class="input-group input-group-static null" style="width: 150px;">
            <label class="">{{ $t('location.Lastcheck_date') }}</label>
            <input v-model="localFormData.toilerDiseaseLastCheckDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('location.Lastcheck_date')">            
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('location.Check_method') }} <small>Method of Toiler disease check (e.g., blood test)</small></label>
            <input v-model="localFormData.toilerDiseaseCheckMethod" type="text" class="form-control form-control-default" :placeholder="$t('location.Check_method')">            
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Upload_certificate') }} </label>
            <div class="d-block mt-1">
              <input
                type="file"
                accept=".pdf"
                class=""
                @change="handleFileUpload($event, 'toilerCertificateFile')"
              />
              <span class="small" v-if="localFormData.toilerCertificateFilePath">{{ localFormData.toilerCertificateFilePath }}</span>           
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <label class="">{{ $t('location.Notes') }} </label>
          <textarea
            v-model="localFormData.toilerNotes"
            class="form-control custom-textarea"
            style="border: 1px solid #ced4da;"
            rows="3"
          ></textarea>
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>                
      </div>
    </div>
  </div>
</template>

<script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import useVuelidate from '@vuelidate/core'
  import { reactive, watch } from 'vue'

  export default {
    name: "ToilerSection",
    props: {
      formData: Object,
      nextStep: Function
    },
    components: {      
      MaterialSwitch,
    },
    mounted() {      
    },    
    setup(props, { emit }) {
      const localFormData = reactive({ ...props.formData })
      const todayDate = new Date().toISOString().split('T')[0];
      const v$ = useVuelidate(localFormData)

      const handleFileUpload = (event, key) => {
        const file = event.target.files[0];
        if (file) {
          localFormData[`${key}Path`] = file.name; // For display
          localFormData[key] = file; // Store actual file for FormData
        }
      };

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndNextStep = async () => {
        v$.value.$touch() // Mark all fields as touched
        if (v$.value.$pending) {
          await v$.value.$validate() // Ensure validation completes
        }
        if (!v$.value.$invalid) {
          props.nextStep()
        }
      }

      return {
        localFormData,
        v$,
        validateAndNextStep,
        handleFileUpload,
        todayDate
      }
    }    
};
</script>
<style scoped>
.custom-textarea {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.5rem;  
}
</style>